import { Text } from "../units/Text"
import { RestApiState } from "../../interfaces/Rest/types"
import { 
    UpdateMyOrganization, 
    UpdateOrganization
} from "../Rest/Organization"
import { 
    BoxWrapper, 
    FlexWrapper 
} from "../Wrappers/Wrappers"
import { SubmitButton } from "../Buttons/buttons"
import { LgFormInput } from "../Form/FormInput"
import { fileHandler } from "../../helpers/fileHandler"
import { OrganizationProps } from "../../interfaces/Organization";
import { EditOrganizationDetailsProps } from "../../pages/Organization/OrganizationEditVIew"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { Client } from "../../roles/roles"
import { useValidatePermission } from "../../roles/roles"
import { PhoneInput_ } from "../Form/FormInput"


const OrganizationAvatar = (
    details: OrganizationProps
    , updateImage: (name:any, value:any) => void
    , imgStatus:string, setImgStatus: (key:string, value:string) => void) => {

    const selectFiles = () => {
        document.getElementById('organizationAvataSelector')?.click()
    }

    const handleFileChange = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        fileHandler(e.target.files[0], setImgStatus, updateImage)
    }

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        document.getElementById('organization-drag-area')?.classList.remove("over-state")
        document.getElementById('blackCircle')?.classList.remove("show-black-circle")

        fileHandler(e.dataTransfer.files[0], setImgStatus, updateImage)
    }


    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        document.getElementById('organization-drag-area')?.classList.add("over-state")
        document.getElementById('blackCircle')?.classList.add("show-black-circle")
    };

    const previewImg = (): (string | null) => {
        if (details.imagePreview) {
            return URL.createObjectURL(details.imagePreview)
        } else if (details.organization_image) {
            return `${process.env.REACT_APP_DJANGO_SERVER_URL}${details.organization_image}`
        } else {
            return null
        }
    }

    const handleDragExit = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        document.getElementById('organization-drag-area')?.classList.remove("over-state")
        document.getElementById('blackCircle')?.classList.remove("show-black-circle")
    }

    return (
        <div>
            <div 
                id='organization-drag-area'
                draggable 
                onDragOver={handleDragOver}
                onDragLeave={handleDragExit}
                onDrop={handleDrop}
                className="organization-image pointer flex align-center justify-center relative"
                onClick={selectFiles}
                >
                {
                    previewImg() === null ? (
                        <Text color="secondary" size="xxxxl">{details.organization_name.slice(0,1).toUpperCase()}</Text>
                    ) : (
                        
                        <img className="organization-img" src={previewImg()!} alt="" />
                    )
                }
                <div className="drag-and-drop-logo flex justify-center">
                    <div id='blackCircle' className='blackCircle flex align-center justify-center'>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 14C9 14.5523 9.4477 15 10 15C10.5523 15 11 14.5523 11 14H9ZM11 2.99997C11 2.44769 10.5523 1.99997 10 1.99997C9.4477 1.99997 9 2.44769 9 2.99997H11ZM13.2929 5.70708C13.6834 6.0976 14.3166 6.0976 14.7071 5.70708C15.0976 5.31655 15.0976 4.68339 14.7071 4.29286L13.2929 5.70708ZM5.29289 4.29286C4.90237 4.68339 4.90237 5.31655 5.29289 5.70708C5.68342 6.0976 6.31658 6.0976 6.70711 5.70708L5.29289 4.29286ZM2 14C2 13.4477 1.55228 13 1 13C0.447721 13 8.76979e-07 13.4477 8.76979e-07 14H2ZM20 14C20 13.4477 19.5523 13 19 13C18.4477 13 18 13.4477 18 14H20ZM11 14V2.99997H9V14H11ZM14.7071 4.29286L11.4142 0.999972L10 2.41418L13.2929 5.70708L14.7071 4.29286ZM8.5858 0.999972L5.29289 4.29286L6.70711 5.70708L10 2.41418L8.5858 0.999972ZM11.4142 0.999972C10.6332 0.218922 9.3668 0.218922 8.5858 0.999972L10 2.41418L11.4142 0.999972ZM8.76979e-07 14V14.2H2V14H8.76979e-07ZM5.8 20H14.2V18H5.8V20ZM20 14.2V14H18V14.2H20ZM14.2 20C15.0236 20 15.7014 20.0008 16.2518 19.9558C16.8139 19.9099 17.3306 19.8113 17.816 19.564L16.908 17.782C16.7516 17.8617 16.5274 17.9266 16.089 17.9624C15.6389 17.9992 15.0566 18 14.2 18V20ZM18 14.2C18 15.0566 17.9992 15.6389 17.9624 16.089C17.9266 16.5274 17.8617 16.7516 17.782 16.908L19.564 17.816C19.8113 17.3306 19.9099 16.8139 19.9558 16.2518C20.0008 15.7014 20 15.0236 20 14.2H18ZM17.816 19.564C18.5686 19.1805 19.1805 18.5686 19.564 17.816L17.782 16.908C17.5903 17.2843 17.2843 17.5903 16.908 17.782L17.816 19.564ZM8.76979e-07 14.2C8.76979e-07 15.0236 -0.000779193 15.7014 0.0441908 16.2518C0.0901208 16.8139 0.188681 17.3306 0.435971 17.816L2.21799 16.908C2.1383 16.7516 2.07337 16.5274 2.03755 16.089C2.00078 15.6389 2 15.0566 2 14.2H8.76979e-07ZM5.8 18C4.94342 18 4.36113 17.9992 3.91104 17.9624C3.47262 17.9266 3.24842 17.8617 3.09202 17.782L2.18404 19.564C2.66937 19.8113 3.18608 19.9099 3.74817 19.9558C4.2986 20.0008 4.97642 20 5.8 20V18ZM0.435971 17.816C0.819471 18.5686 1.43139 19.1805 2.18404 19.564L3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908L0.435971 17.816Z" fill="white"/>
                        </svg>
                    </div>
                </div>
            </div>
            <input
                id="organizationAvataSelector"
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={handleFileChange}
                style={{ display: 'none' }}/>
            <br />
            <div className="flex" style={{width: '140px', maxWidth: '140px', textAlign: "center"}}>
                <Text size="sm" color="secondary" className="text-wrap" >{imgStatus}</Text>
            </div>
        </div>
    )
}


export const EditOrganization = ({ details, setter }: EditOrganizationDetailsProps)  => {
    const organization = details.organization
    const { user } = useSignedInContext()
    useValidatePermission({role: user.role, resource:'Organization', action: 'update'})

    const setEditOrganizationObject = (key: string, value: any):void => {
        setter((prev:any) => (
            {...prev, editOrganizationDetails: {
                ...prev.editOrganizationDetails,
                organization: {
                    ...prev.editOrganizationDetails.organization,
                    [key]: value}}
                }
        ))
    }

    const handelSubmit = (e: any) => {
        e.preventDefault();
        if (details.organization && details.requestState !== RestApiState.Pending) {
            setter((prev:any) => ({
                ...prev,
                editOrganizationDetails: {
                    ...prev.editOrganizationDetails,
                        requestState: RestApiState.Pending
                }
            }))
            if (user.role === Client) {
                UpdateMyOrganization(details.organization, (value: RestApiState) => {
                    setter((prev:any) => ({
                        ...prev,
                        editOrganizationDetails: {
                            ...prev.editOrganizationDetails,
                                requestState: value
                        }
                    }))
                })
            } else {
                UpdateOrganization(details.organization, (value: RestApiState) => {
                    setter((prev:any) => ({
                        ...prev,
                        editOrganizationDetails: {
                            ...prev.editOrganizationDetails,
                                requestState: value
                        }
                    }))
                })
            }
    
        }
    }

    const updateField = (e: React.ChangeEvent<HTMLInputElement>):void => {
        const { name, value } = e.target;
        if (details.organization) {
            setter((prev:any) => ({
                ...prev,
                editOrganizationDetails: {
                    ...prev.editOrganizationDetails,
                    organization : {
                        ...prev.editOrganizationDetails.organization,
                        [ name ] : value
                    }
                }
            }))
        }
    }

    const updateImage = (name:any, value:any):void => {
        if (details.organization) {
            setter((prev:any) => ({
                ...prev,
                editOrganizationDetails: {
                    ...prev.editOrganizationDetails,
                    organization : {
                        ...prev.editOrganizationDetails.organization,
                        [ name ] : value
                    }
                }
            }))
        }
    }
    if (organization) {
        return (
                <BoxWrapper bg="bg-primary" p="p3" r="r15">
                    <Text size="lg" className="bold dispaly-block">Редактировать данные организации</Text>
                    <br />
                    <br />
                    <form onSubmit={handelSubmit} className="organization-form">
                        <div className="flex">
                            { OrganizationAvatar(organization, updateImage, details.imgStatus, setEditOrganizationObject) }
                            <div className="flex flex-column flex-grow">
                                <LgFormInput value={organization.address} label='Адрес' name='address' type='text' required={true} valueSetter={updateField}/>
                                <PhoneInput_ name="phone"
                                            value={organization.phone}
                                            setter={ (e:any) => {
                                                setter((prev:any) => ({
                                                    ...prev,
                                                    editOrganizationDetails: {
                                                        ...prev.editOrganizationDetails,
                                                        organization : {
                                                            ...prev.editOrganizationDetails.organization,
                                                            phone : e
                                                        }
                                                    }
                                                }))
                                            } }
                                            label="Телефон"
                                            required={true}
                                            showErros={false}
                                            type='text'/>
                                <LgFormInput value={organization.email} label='Почта' name='email' type='text' required={true} valueSetter={updateField}/>
                                <Text size="lg" className="bold">Отображение информации:</Text>
                                
                                <div className="flex wide-gap flex-wrap">
                                    <div className="flex narrow-gap align-center">
                                        <label className="switch">
                                        
                                            <input type="checkbox" onClick={() => {setEditOrganizationObject('allow_building_grouping', !organization.allow_building_grouping)}}  defaultChecked={organization.allow_building_grouping} />
                                            <span className="slider"></span>
                                        </label>
                                        <Text>Группировка по объектам</Text>
                                    </div>
                                    <div className="flex narrow-gap align-center">
                                        <label className="switch">
                                            <input type="checkbox" onClick={() => {setEditOrganizationObject('allow_custom_model_grouping', !organization.allow_custom_model_grouping)}}  defaultChecked={organization.allow_custom_model_grouping}/>
                                            
                                            <span className="slider"></span>
                                        </label>
                                        <Text>Группировка по типам техники</Text>
                                    </div>
                                </div>
                        
                                <br />
                                <br />
                                <FlexWrapper>
                                    <SubmitButton 
                                            restState={details.requestState}
                                            disabled={details.requestState !== RestApiState.Idle}
                                            restHandler={{
                                                timeOutId: details.timeOutId,
                                                setter: (key: 'requestState' | 'timeOutId', value: any) => {
                                                    setter((prev:any) => ({
                                                        ...prev,
                                                        editOrganizationDetails: {
                                                            ...prev.editOrganizationDetails,
                                                                [key]: value
                                                        }
                                                    }))
                                                }
                                            }}
                                        />
                                </FlexWrapper>
                            </div>
                            <br />
                        </div>
                    </form>
                </BoxWrapper>
        )
    } else {
        return (
            <div>Loading State that needs refactoring</div>
        )
    }
}